import type { ActionTree, Module, MutationTree } from 'vuex';
import type { SponsoredAdFragment } from '@/pages/graphql/fragments/SponsoredAd.fragment';
import type { SRCatalogueKey } from '@/components/sponsored-recommendations/useSendBidId';

import Vue from 'vue';

// STATE
const state = () => ({
	catalogue: {} as Partial<Record<SRCatalogueKey, SponsoredAdFragment>>,
});

type SponsoredRecommendationsState = ReturnType<typeof state>;

// ACTIONS
const actions: ActionTree<SponsoredRecommendationsState, any> = {
	setSponsoredAd({ commit }, payload: { catalogueKey: SRCatalogueKey; ad: SponsoredAdFragment }) {
		commit('SET_SPONSORED_AD', payload);
	},

	clearSponsoredAd({ commit }, catalogueKey: SRCatalogueKey) {
		commit('CLEAR_SPONSORED_AD', catalogueKey);
	},

	clearAllSponsoredAds({ commit }) {
		commit('CLEAR_ALL_SPONSORED_ADS');
	},
};

// MUTATIONS
const mutations: MutationTree<SponsoredRecommendationsState> = {
	SET_SPONSORED_AD(state, { catalogueKey, ad }: { catalogueKey: SRCatalogueKey; ad: SponsoredAdFragment }) {
		Vue.set(state.catalogue, catalogueKey, ad);
	},

	CLEAR_SPONSORED_AD(state, catalogueKey: SRCatalogueKey) {
		Vue.delete(state.catalogue, catalogueKey);
	},

	CLEAR_ALL_SPONSORED_ADS(state) {
		Vue.set(state, 'catalogue', {});
	},
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
} as Module<SponsoredRecommendationsState, any>;
